module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-item row",
    staticStyle: {
      "width": "470px !important"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showFieldLabel) ? _c('span', {
    staticClass: "item-label"
  }, [_vm._v(_vm._s(_vm.label) + ":")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 values"
  }, [_vm._l(([_vm.sortedFields[0]]), function(field, i) {
    return _c('span', {
      key: i
    }, [_c('el-tooltip', {
      attrs: {
        "placement": "bottom",
        "effect": "light"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('strong', [_vm._v("Confirmations:")]), _vm._v("\n          " + _vm._s(_vm.getFieldValue(field).confirmations) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Score:")]), _vm._v("\n          " + _vm._s(_vm.getFieldValue(field).score.toFixed(2)) + "\n        ")]), _vm._v(" "), (_vm.getFieldLabel(field) && !Array.isArray(_vm.getFieldValue(field).value) && field !== null) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.showNuggetOptions(_vm.getFieldValue(field).value)
        }
      }
    }, [_c('el-tag', {
      staticClass: "item-value",
      attrs: {
        "size": "small"
      }
    }, [_vm._v("\n            " + _vm._s(field && field.hasOwnProperty('friendly_value') ?
      field.friendly_value :
      _vm.findLangaugeNameFromKey(_vm.getFieldValue(field).value).includes('N/A') ?
      _vm.getFieldValue(field).value :
      _vm.findLangaugeNameFromKey(_vm.getFieldValue(field).value)) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (Array.isArray(_vm.getFieldValue(field).value)) ? _c('span', _vm._l((_vm.getFieldValue(field).value), function(value) {
      return _c('span', {
        key: value,
        staticClass: "item-value",
        style: ({
          'background-color': _vm.scoreColor(_vm.getFieldValue(field).value, field),
        }),
        attrs: {
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.showNuggetOptions(value)
          }
        }
      }, [_vm._v(_vm._s(value))])
    }), 0) : _vm._e()])], 1)
  }), _vm._v(" "), (_vm.label === 'Location') ? _c('span', {
    staticClass: "location-marker",
    on: {
      "click": _vm.handleOpenProfileMap
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('NuggetOptions', {
    attrs: {
      "show": _vm.optionsVisible,
      "nuggetValue": _vm.selectedNuggetValue,
      "nuggetLabel": _vm.label,
      "nuggetKey": _vm.fieldKey,
      "category": _vm.category,
      "profileId": _vm.profileId
    },
    on: {
      "closeDialog": _vm.closeOptionsDialog,
      "removeNugget": function (cfg) { return _vm.$emit('removeNugget', cfg); },
      "blacklistNugget": function (cfg) { return _vm.$emit('blacklistNugget', cfg); }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84d1674a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profile/ProfileDetailFieldItem.vue
// module id = 3360
// module chunks = 3